import type { Language } from '@/i18n'

// en-GB, not en-US: day-first worded dates ("Monday, 28 September") and a 24-hour
// clock by default. Numeric dates bypass Intl entirely; see lib/dates.
const locales: Record<Language, string> = { en: 'en-GB', ro: 'ro-RO' }

let current = locales.en

/** Kept in sync by LanguageProvider so non-component date helpers can localize. */
export function setCrmLocale(language: Language) {
  current = locales[language] ?? locales.en
}

export function getCrmLocale() {
  return current
}

let currentLanguage: Language = 'en'

/**
 * The raw language tag, for the few places that must resolve a string outside a
 * component and therefore cannot call useCrmT — currently the global mutation
 * error handler, which lives on the QueryClient rather than in the React tree.
 */
export function setCrmLanguage(language: Language) {
  currentLanguage = language
}

export function getCrmLanguage(): Language {
  return currentLanguage
}
